let currentUrl = new URL(window.location.href);
let params = new URLSearchParams(currentUrl.search);

/*
 * Prevent domain redirects inside:
 * - Shopify Theme Editor
 * - Theme preview
 * - Draft product preview
 */
const isShopifyEditorOrPreview =
  (typeof Shopify !== "undefined" && Shopify.designMode) ||
  window.location.hostname.includes("shopifypreview.com") ||
  params.has("preview_theme_id") ||
  params.has("preview_key") ||
  window.location.pathname.includes("/products_preview");

if (params.get("or") === "true") {
  setCookie("currency_overide", "true", 7);
  console.log("currency_overide cookie set to true");
}

var currency_overide = getCookie("currency_overide");
console.log("currency_overide:" + currency_overide);

/*
 * Automatic country redirect.
 * Do not run inside Shopify editor/preview.
 */
if (currency_overide == null && !isShopifyEditorOrPreview) {
  fetch("https://ipapi.co/json/")
    .then((response) => response.json())
    .then((data) => {
      const userCountry = data.country;
      const currentDomain = window.location.hostname;

      // US visitors on Canadian site → US site
      if (
        userCountry === "US" &&
        currentDomain.includes("thecoverbrothers.ca")
      ) {
        window.location.href = window.location.href.replace(
          "thecoverbrothers.ca",
          "thecoverbrothers.net"
        );
      }

      // Canadian visitors on US site → Canadian site
      else if (
        userCountry === "CA" &&
        currentDomain.includes("thecoverbrothers.net")
      ) {
        window.location.href = window.location.href.replace(
          "thecoverbrothers.net",
          "thecoverbrothers.ca"
        );
      }

      // International visitors → Canadian site
      else if (!["US", "CA"].includes(userCountry)) {
        if (!currentDomain.includes("thecoverbrothers.ca")) {
          window.location.href = window.location.href.replace(
            currentDomain,
            "thecoverbrothers.ca"
          );
        }
      }
    })
    .catch((error) => {
      console.warn("Geolocation lookup failed:", error);
    });
}

function getCookie(name) {
  let match = document.cookie.match(
    new RegExp("(^| )" + name + "=([^;]+)")
  );

  return match ? match[2] : null;
}

function setCookie(name, value, days) {
  var expires = "";

  if (days) {
    var date = new Date();

    date.setTime(
      date.getTime() +
      days * 24 * 60 * 60 * 1000
    );

    expires = "; expires=" + date.toUTCString();
  }

  document.cookie =
    name +
    "=" +
    (value || "") +
    expires +
    "; path=/";
}

$(document).ready(function () {
  // Default to CAD if no cookie is set
  let cartCurrency = getCookie("cart_currency") || "CAD";

  // Set the correct flag and text based on the cookie
  let selectedItem = $(
    ".cs_dropdown-item[data-value='" + cartCurrency + "']"
  );

  let selectedFlag = selectedItem.data("flag");
  let selectedText = selectedItem.data("text");

  console.log("load country:" + selectedText);

  $(".cs_flag-img").attr("src", selectedFlag);
  $(".cs_selected-text").empty();
  $(".cs_selected-text").text(selectedText);

  // Highlight the selected option
  $(".cs_dropdown-item").removeClass("active");
  selectedItem.addClass("active");

  // Handle currency selection
  $(document).on("click", ".cs_dropdown-item", function () {
    console.log("working down-item");

    let newCurrency = $(this).data("value");
    let newFlag = $(this).data("flag");
    let newText = $(this).data("text");

    $(".cs_flag-img").attr("src", newFlag);
    $(".cs_selected-text").empty();
    $(".cs_selected-text").text(newText);

    // Highlight the selected item
    $(".cs_dropdown-item").removeClass("active");
    $(this).addClass("active");

    /*
     * Never redirect the Shopify Theme Editor
     * or preview window.
     */
    if (isShopifyEditorOrPreview) {
      console.log("Currency redirect skipped in Shopify editor/preview");
      return;
    }

    // Update cookies
    setCookie("cart_currency", newCurrency, 7);
    setCookie("currency_overide", "true", 7);

    // Redirect based on selected currency
    let baseUrl = "";

    if (newCurrency === "CAD") {
      baseUrl = "https://thecoverbrothers.ca";
    } else if (newCurrency === "USD") {
      baseUrl = "https://thecoverbrothers.net";
    } else {
      baseUrl = window.location.origin;
    }

    const targetUrl = `${baseUrl}/?or=true`;

    console.log("url:" + targetUrl);

    window.location.replace(targetUrl);
  });
});